import { Inject, Injectable } from '@angular/core';
import { ANGULARJS_SERVICE_UPGRADE_TOKENS } from '../angularjs-service-upgrade.enum';

@Injectable({
    providedIn: 'root',
})
export class LegacyStateService {
    constructor(@Inject(ANGULARJS_SERVICE_UPGRADE_TOKENS.STATE_TOKEN) private _angularState: any) { }

    goToLogout() {
        this._angularState.go('logout');
    }
}